import { render, staticRenderFns } from "./StatesEdit.vue?vue&type=template&id=1d151452"
import script from "./StatesEdit.vue?vue&type=script&lang=js"
export * from "./StatesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports